// extracted by mini-css-extract-plugin
export default {"element":"PriceList_element__G0bqh","line":"PriceList_line__QMHD9","separator":"PriceList_separator__9OG0l"};